import { types } from '../../actions/dashboard/newentry';

export default function newentryReducer(
	state = {
		newEntryData: [],
		visiterData: null,
		visiterEntries: null,
		employeeData: null,
		didInvalidate: true,
		showNewEntry: false,
		entrySuccess: false,
		isLoaded: [],
		isUpdated: false,
		isDeleted: false,
	},
	action
) {
	const payload = action.payload;
	switch (action.type) {
		case types.INVALIDATE_NEW_ENTRY:
			return {
				...state,
				didInvalidate: true,
			};
		case types.REQUEST_VISITER_ENTRIES:
			return {
				...state,
				didInvalidate: false,
			};
		case types.RECEIVE_VISITER_ENTRIES:
			return {
				...state,
				didInvalidate: false,
				visiterEntries: payload.visiterEntries,
			};
		case types.REQUEST_VISITER_LIST:
			return {
				...state,
				didInvalidate: false,
			};
		case types.RECEIVE_VISITER_LIST:
			return {
				...state,
				didInvalidate: false,
				visiterData: payload.visiterData,
			};
		case types.REQUEST_EMPLOYEE_LIST:
			return {
				...state,
				didInvalidate: false,
			};
		case types.RECEIVE_EMPLOYEE_LIST:
			return {
				...state,
				didInvalidate: false,
				employeeData: payload.employeeData,
			};
		case types.INSERT_NEW_ENTRY:
			return {
				...state,
				didInvalidate: false,
			};
		case types.INSERT_NEW_ENTRY_DETAIL:
			return {
				...state,
				didInvalidate: false,
			};
		case types.SET_SHOW_NEW_ENTRY:
			return {
				...state,
				didInvalidate: false,
				showNewEntry: payload,
			};
		case types.INSERT_NEW_ENTRY_STATUS:
			return {
				...state,
				didInvalidate: false,
				entrySuccess: payload,
			};
		case types.UPDATE_VISITER_ENTRIES:
			return {
				...state,
				didInvalidate: false,
			};
		case types.SEND_EMPLOYEE_MAIL:
			return {
				...state,
				didInvalidate: false,
			};
		case types.GET_VISITOR_DATA:
			return {
				...state,
				...payload,
			};
		case types.UPDATE_VISITER_TIME:
			return {
				...state,
				...payload,
			};
		case types.DELETE_VISITER_DATA:
			return {
				...state,
				...payload,
			};
		default:
			return state;
	}
}
